if (!customElements.get('product-form')) {
	customElements.define(
	  'product-form',
	  class ProductForm extends HTMLElement {
		constructor() {
		  super();
  
		  this.form = this.querySelector('form');
		  if (this.form) {
		  this.form.querySelector('[name=id]').disabled = false;
		  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
		  }
		  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		  this.submitButton = this.querySelector('[type="submit"]');
  
		  if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
		  this.hideErrors = this.dataset.hideErrors === 'true';
		}
  
		onSubmitHandler(evt) {
		  evt.preventDefault();
		  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

		  // Gymatics personalisation (assets/gymatics-personalise.js): check the name before adding
		  const personaliseError = window.GymaticsPersonalise ? window.GymaticsPersonalise.validate(this.form) : null;
		  if (personaliseError) return;

		  this.error = false;

		  this.handleErrorMessage();

		  this.submitButton.setAttribute('aria-disabled', true);
		  this.submitButton.classList.add('loading');
  
		  if (this.querySelector('.loading__spinner')) {
			this.querySelector('.loading__spinner').classList.remove('hidden');
		  }
  
		  const config = fetchConfig('javascript');
		  config.headers['X-Requested-With'] = 'XMLHttpRequest';
		  delete config.headers['Content-Type'];
  
		  const formData = new FormData(this.form);
		  if (this.cart) {
			formData.append(
			  'sections',
			  this.cart.getSectionsToRender().map((section) => section.id)
			);
			formData.append('sections_url', window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		  }
		  config.body = window.GymaticsPersonalise ? window.GymaticsPersonalise.transform(this.form, formData) : formData;
  
		  fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
			  if (response.status) {
				publish(PUB_SUB_EVENTS.cartError, {
				  source: 'product-form',
				  productVariantId: formData.get('id'),
				  errors: response.errors || response.description,
				  message: response.message,
				});
				this.handleErrorMessage(response.description);

				this.error = true;

				const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
				if (soldOutMessage) {
				  this.submitButton.setAttribute('aria-disabled', true);
				  const submitLabel = this.submitButton.querySelector('span');
				  if (submitLabel) submitLabel.classList.add('hidden');
				  soldOutMessage.classList.remove('hidden');
				}

				this.refreshCartSections();
				return;
			  } else if (!this.cart) {
				window.location = window.routes.cart_url;
				return;
			  }
  
			  if (!this.error)
				publish(PUB_SUB_EVENTS.cartUpdate, {
				  source: 'product-form',
				  productVariantId: formData.get('id'),
				  cartData: response,
				});
				
			  this.error = false;
			  const quickAddModal = this.closest('quick-add-modal');
			  if (quickAddModal) {
				document.body.addEventListener(
				  'modalClosed',
				  () => {
					setTimeout(() => {
					  this.cart.renderContents(response);
					});
				  },
				  { once: true }
				);
				quickAddModal.hide(true);
			  } else {
				this.cart.renderContents(response);
			  }
			})
			.catch((e) => {
			  console.error(e);
			})
			.finally(() => {
			  this.submitButton.classList.remove('loading');
			  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

			  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
			  const showSoldOutUi =
				soldOutMessage && !soldOutMessage.classList.contains('hidden');

			  if (!showSoldOutUi) {
				this.submitButton.removeAttribute('aria-disabled');
			  }

			  if (this.querySelector('.loading__spinner')) {
				this.querySelector('.loading__spinner').classList.add('hidden');
			  }
			});
		}

		refreshCartSections() {
		  const cart = this.cart;
		  if (!cart || typeof cart.getSectionsToRender !== 'function') return;

		  const sectionIds = cart.getSectionsToRender().map((section) => section.id).join(',');
		  const url = new URL(window.location.href);
		  url.searchParams.set('sections', sectionIds);

		  fetch(url.toString())
			.then((res) => res.json())
			.then((data) => {
			  const sections = data.sections || data;
			  cart.getSectionsToRender().forEach((section) => {
				const html = sections[section.id];
				if (!html) return;
				const sectionElement = section.selector
				  ? document.querySelector(section.selector)
				  : document.getElementById(section.id);
				if (!sectionElement) return;
				sectionElement.innerHTML = cart.getSectionInnerHTML(html, section.selector);
			  });

			  if (cart.tagName === 'CART-DRAWER') {
				setTimeout(() => {
				  const overlay = cart.querySelector('#CartDrawer-Overlay');
				  if (overlay) overlay.addEventListener('click', cart.close.bind(cart));
				});
			  }

			  return fetch(`${routes.cart_url}.js`).then((r) => r.json());
			})
			.then((cartJson) => {
			  if (!cartJson || typeof cartJson.item_count !== 'number') return;

			  const cartDrawer = document.querySelector('cart-drawer');
			  if (cartDrawer) {
				cartDrawer.classList.toggle('is-empty', cartJson.item_count === 0);
			  }

			  document.querySelectorAll('.totals__items').forEach((el) => {
				el.textContent = cartJson.item_count;
			  });
			})
			.catch((e) => console.error(e));
		}
  
		handleErrorMessage(errorMessage = false) {
		  if (this.hideErrors) return;
  
		  this.errorMessageWrapper =
			this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
		  if (!this.errorMessageWrapper) return;
		  this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
		  this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
		  if (errorMessage) {
			this.errorMessage.textContent = errorMessage;
		  }
		}
	  }
	);
  }
  